
import LocalStorageHelper from './LocalStorageHelper';

/**
 * Получает валюту инвестиций из localStorage
 * Возвращает объект {id, name} или {id: 'none', name: 'Валюта актива'} по умолчанию
 * Используется для унификации получения валюты инвестиций во всех компонентах
 * @param {string} storageKey - ключ для чтения из localStorage (по умолчанию LocalStorageHelper.INVEST_CURRENCY)
 * @returns {{id: string|number, name: string}}
 */
export const getInvestCurrency = (storageKey = LocalStorageHelper.INVEST_CURRENCY) => {
  try {
    const investCurrencyData = localStorage.getItem(storageKey);
    if (investCurrencyData) {
      return JSON.parse(investCurrencyData);
    }
  } catch (err) {
    console.warn('[getInvestCurrency] Не удалось получить валюту из localStorage:', err);
  }
  return {id: 'none', name: 'Валюта актива'};
};
